import { ProductsApiRemoteService } from '../../Services/api/products/products-service'
import { IExportProductPayload, IProductEntity } from '../../Services/api/products/products.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class ExportExcelProductUseCase
implements IFormUsecase<IExportProductPayload, Blob> {
  constructor (private readonly ProductsApi: ProductsApiRemoteService) {}
    

  public async handle (
    data: IExportProductPayload
  ): Promise<Result<Blob>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ProductsApi.exportExcel(data)

      if (response.isFailure) {
        return response
      }

      const blob = response.getValue() as Blob

      if(!blob) return response

    
      return Result.ok(blob)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
